<template>
  <div class="saw-engraving-setting h100 y-auto" ref="sawEngravingRef">
    <div class="saw-engraving-setting-header">
      <!-- 锯切雕刻机 -->
      <div class="flex flex-cross--center">
        <span id="span_mhh1nq01bi" class="color-o-9 mr16 fs20">{{
          $t('cuttingDock.sawEngraving.enableSaw')
        }}</span>
        <a-switch
          id="engraving_setting_saw_engraving_switch"
          v-model="formData.mentaoji_enable"
        ></a-switch>
      </div>
      <div class="export_data_setting" v-if="formData.mentaoji_enable">
        <div>
          <span class="color-o-9">{{
            $t('cuttingDock.sawEngraving.exportPartData')
          }}</span>
          <a-checkbox
            id="exportPlankData_checkoubox"
            class="ml8"
            v-model="formData.saw_aio_setting.saw_aio_enable"
            v-bp="'engraving:exportPlankData'"
            @change="handleChangeExportPlankData"
          ></a-checkbox>
          <span class="color-o-4 ml8"
            >({{ $t('cuttingDock.sawEngraving.sawAioTip2') }})</span
          >
        </div>
        <div
          v-show="formData.saw_aio_setting.saw_aio_enable"
          class="cut-setting-item"
        >
          <span class="color-o-9"> {{ $t('dock56Drill.fileType') }}： </span>
          <a-select
            v-model="formData.saw_aio_setting.saw_aio_model"
            style="width: 200px"
            show-search
            :filter-option="filterSawAioOption"
            @change="handleChangeSawAioModel"
          >
            <a-select-option
              v-for="(item, index) in dockFiveSixTemplates"
              :key="index"
              :value="item.dock56Format"
              v-bp="'engraving:aioSawModal'"
              :id="`engraving_setting_aioSawModal_option_${index}`"
              >{{ item.modelName }}</a-select-option
            >
          </a-select>
          <span class="down_line" v-if="isNotEnableSawAioModel">
            {{ $t('cuttingDock.labelingSettings.templateOffline') }}
          </span>
        </div>
        <robot-arm-setting
          :visible="
            formData.mentaoji_enable && formData.saw_aio_setting.saw_aio_enable
          "
          :enable="roboticArmSetting.enable"
          :robotic-arm-model="roboticArmSetting.robotic_arm_model"
          :robotic-options="roboticOptions"
          id-prefix="engraving_setting_saw_engraving_robot_arm_"
          @update:enable="handleRobotArmEnableChange"
          @update:robotic-arm-model="handleRobotArmModelChange"
        ></robot-arm-setting>
      </div>
    </div>
    <div
      v-show="
        formData.mentaoji_enable && !formData.saw_aio_setting.saw_aio_enable
      "
    >
      <div class="knives-store">
        <!-- 刀库 -->
        <span id="span_2zasiu0jwh" class="title">{{
          $t('common.knivesStore')
        }}</span>
        <div class="main-table">
          <page-table
            class="mentaoji"
            :dataFrom="'mentaoji'"
            :tableConfig="tableConfig"
            :data="formData.mentaoji_saws"
            @clickRow="clickRow"
            @tableInputChange="tableInputChange"
          >
            <template #saw_direction="{ row }">
              <a-radio-group
                v-model="row.saw_direction"
                id="engraving_setting_mentaoji_saws_saw_direction_radio"
              >
                <a-radio id="a_radio_ob25o9oht8" value="H">{{
                  $t('cuttingDock.knives.sawHor')
                }}</a-radio>
                <br />
                <a-radio id="a_radio_5sst8vx86s" value="V">{{
                  $t('cuttingDock.knives.sawVer')
                }}</a-radio>
              </a-radio-group>
            </template>
            <template #cut_from="{ row }">
              <a-radio-group
                v-model="row.cut_from"
                id="engraving_setting_mentaoji_saws_cut_from_radio"
              >
                <a-radio id="a_radio_whkzl3np4n" value="0000">{{
                  $t('cuttingDock.knives.towardsZero')
                }}</a-radio>
                <br />
                <a-radio id="a_radio_rpdk5h5og4" value="9999">{{
                  $t('cuttingDock.knives.awayFromZero')
                }}</a-radio>
              </a-radio-group>
            </template>
          </page-table>
        </div>
        <div class="operation-btn">
          <!-- 插入行 -->
          <a-button
            @click="addLineMentaoji"
            class="mr12"
            id="engraving_setting_mentaoji_saws_table_add_row"
            >{{ $t('cuttingDock.knives.insert') }}</a-button
          >
          <!-- 删除行 -->
          <a-button
            @click="deleteLineMentaoji"
            id="engraving_setting_mentaoji_saws_table_delete_row"
            class="danger-btn"
            >{{ $t('cuttingDock.knives.delete') }}</a-button
          >
        </div>
      </div>
      <div class="cut-setting">
        <!-- 切割设置 -->
        <div class="flex flex-cross--center">
          <span id="span_g9cv2obh6e" class="title">{{
            $t('cuttingDock.sawEngraving.cutSet')
          }}</span>
        </div>
        <div class="flex">
          <div>
            <div class="cut-setting-item">
              <span id="span_qgxvn7taho" class="label"
                >{{ $translateLang('加工工艺') }}：</span
              >
              <a-radio-group
                v-model="formData.processType"
                @change="handleChangeProcessType"
              >
                <a-radio value="weldingPlank">
                  {{ $translateLang('焊接板') }}
                </a-radio>
                <a-radio value="doorFrame">
                  {{ $translateLang('门套') }}
                  <span class="color-o-4 ml5"
                    >(1.<span style="color: red">{{
                      $translateLang('下料刀半径必须≤锯片厚度')
                    }}</span>
                    {{
                      $translateLang('2.不支持异形板件排版 3.排版间隙自动为0')
                    }})</span
                  >
                </a-radio>
              </a-radio-group>
            </div>
            <div class="cut-setting-item">
              <!-- 锯片用途 -->
              <span id="engraving_setting_sawUsing_label" class="label mr18"
                >{{ $t('cuttingDock.sawEngraving.sawUsing') }}：</span
              >
              <a-checkbox
                id="engraving_setting_sawToTrim_checkbox"
                v-model="formData.sawToTrim"
                :disabled="
                  formData.sawToLayout || formData.processType === 'doorFrame'
                "
                >{{ $t('cuttingDock.sawEngraving.trim') }}</a-checkbox
              >
              <a-checkbox
                id="engraving_setting_sawToCut_checkbox"
                v-model="formData.sawToCut"
                :disabled="
                  formData.sawToLayout || formData.processType === 'doorFrame'
                "
                >{{ $t('cuttingDock.sawEngraving.cutBlank') }}</a-checkbox
              >
            </div>
            <div class="cut-setting-item">
              <!-- 不生成纵向锯片切割路径 -->
              <span id="span_nenueddp0l" class="color-o-9 mr8">{{
                $t('cuttingDock.cuttingParams.unGenSawPath')
              }}</span>
              <a-checkbox
                id="engraving_setting_noVerticalSaw_checkbox"
                v-model="formData.noVerticalSaw"
              ></a-checkbox>
            </div>
            <div class="cut-setting-item">
              <!-- 锯片使用条件 -->
              <span id="span_naab9myv2y" class="label"
                >{{ $t('cuttingDock.sawEngraving.sawUseCond') }}：</span
              >
              <a-radio-group v-model="formData.mentaojiSizeSetting">
                <a-radio
                  id="engraving_setting_mentaojiSizeSetting_radio_false"
                  :value="false"
                >
                  {{ $t('cuttingDock.sawEngraving.hasUsing') }}
                </a-radio>
                <a-radio
                  id="engraving_setting_mentaojiSizeSetting_radio_true"
                  :value="true"
                  :disabled="
                    formData.sawToLayout || formData.processType === 'doorFrame'
                  "
                >
                  {{ $t('cuttingDock.cuttingParams.restSizeLimit') }}
                  <a-input
                    id="engraving_setting_mentaojiSizeSetting_input"
                    v-model="formData.mentaojiSize"
                    suffix="mm"
                    class="mh8"
                    style="width: 100px"
                    @input="inputCheck('mentaojiSize', false, 1)"
                  ></a-input>
                  {{ $t('cuttingDock.sawEngraving.onlyUse') }}
                </a-radio>
              </a-radio-group>
            </div>
            <div class="cut-setting-item">
              <!-- 切割方式 -->
              <span id="span_v8z2ckagrf" class="label"
                >{{ $t('cuttingDock.sawEngraving.cutMethod') }}：</span
              >
              <a-radio-group v-model="formData.sawThrough">
                <a-radio
                  id="engraving_setting_sawThrough_radio_false"
                  :value="false"
                  style="margin-right: 35px; margin-left: -1px"
                >
                  {{ $t('cuttingDock.sawEngraving.oneKnifePull') }}
                </a-radio>
                <a-radio
                  id="engraving_setting_sawThrough_radio_true"
                  :value="true"
                >
                  {{ $t('cuttingDock.cuttingParams.restSizeLimit') }}
                  <a-input
                    id="engraving_setting_sawThroughSize_input"
                    v-model="formData.sawThroughSize"
                    suffix="mm"
                    class="mh8"
                    style="width: 100px"
                    @input="inputCheck('sawThroughSize', false, 1)"
                  ></a-input>
                  {{ $t('cuttingDock.sawEngraving.onlyOneKnifePull') }}
                </a-radio>
              </a-radio-group>
            </div>
            <div
              class="cut-setting-item"
              v-show="formData.processType === 'weldingPlank'"
            >
              <!-- 启用锯片厚度排版 -->
              <span id="span_ufgyql9xlf" class="label label-width">{{
                $t('cuttingDock.sawEngraving.enableSawThick')
              }}</span>
              <a-switch
                id="engraving_setting_sawToLayout_switch"
                v-model="formData.sawToLayout"
                @change="handleChangeThickLay"
              ></a-switch>
              <div class="ml10 mt5 flex">
                <div>
                  <div class="ml10 color-o-4">
                    <div id="div_hxk83togmj" class="ml10 color-o-4">
                      {{
                        $translateLang(
                          '启用该功能后排版时小板间只会预留等于锯片厚度的切割缝'
                        )
                      }}
                    </div>
                  </div>
                  <div
                    id="div_b72gqprjfq"
                    class="color-o-4 mt5"
                    style="margin-left: 20px"
                  >
                    {{ $translateLang('注意') }}：{{
                      $translateLang('锯切排版暂不支持指定下料刀')
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="cut-setting-item"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <!-- 已封好不再切的大板边 -->
              <span id="span_leto29mf1s" class="color-o-9 mr8">{{
                $t('cuttingDock.sawEngraving.edgedDir')
              }}</span>
              <a-checkbox
                class="mr20"
                v-model="formData.edgeNoSaw"
                id="engraving_setting_edgeNoSaw_checkbox"
              ></a-checkbox>
              <div class="edge-warp">
                <span
                  class="ellipsis"
                  v-for="(item, index) in edgeDirArr"
                  :key="index"
                  @click="handleSelectEdge(item.value)"
                  :id="`saw_engraving_setting_edge_${index}_btn`"
                  :title="translateLang(item.label)"
                  :class="{ active: formData.edgeNoSawSide == item.value }"
                  >{{ $t(item.label) }}</span
                >
              </div>
            </div>
            <div
              class="cut-setting-item"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <span id="span_woqvww7pa1" class="color-o-9 mr8">{{
                $translateLang('每张大板上只排相同宽度小板')
              }}</span>
              <a-checkbox
                id="cut-setting_sameWidthPlank_checkbox"
                class="mr20"
                v-model="formData.sameWidthPlank"
                v-bp="'engraving:sameWidthPlank'"
              ></a-checkbox>
            </div>
            <div
              class="cut-setting-item"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <span id="span_nic0u47eyj" class="color-o-9 mr8"
                >{{ $translateLang('按板件长度依次排版') }}:</span
              >
              <a-radio-group class="ml8" v-model="formData.sortByHeight">
                <a-radio
                  id="engraving_setting_sortByHeight_radio_top"
                  :value="'top'"
                  v-bp:change="'engraving:plankAtTop'"
                  >{{ $translateLang('小板在上') }}</a-radio
                >
                <a-radio
                  id="engraving_setting_sortByHeight_radio_bottom"
                  :value="'bottom'"
                  v-bp:change="'engraving:plankAtBottom'"
                  >{{ $translateLang('小板在下') }}</a-radio
                >
              </a-radio-group>
              <span id="span_kyc8tuyrv2" class="color-o-4">
                ({{
                  $translateLang(
                    '切割方向是从下到上依次切割，排板是先按宽度再按长度排'
                  )
                }})
              </span>
            </div>
            <div
              class="cut-setting-item"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <span id="span_5ktbdhrxw5" class="color-o-9 mr8">
                {{ $translateLang('切割时不生成空走路径') }}
              </span>
              <a-checkbox
                id="engraving_setting_noCutEmptyPath_checkbox"
                v-model="formData.noCutEmptyPath"
                class="mr20"
              >
              </a-checkbox>
            </div>
            <div
              class="cut-setting-item div-margin"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <newContent :is-new-content="false">
                <span id="span_zyfbwhm7n8" class="color-o-9 mr8">
                  {{ $translateLang('焊接板才使用锯片加工') }}
                </span>
              </newContent>
              <a-checkbox
                id="engraving_setting_sawCutOnlyWeld_checkbox"
                v-bp="'engraving:sawCutOnlyWeld'"
                v-model="formData.sawCutOnlyWeld"
                class="mr20"
              ></a-checkbox>
              <div class="ml10 mt5 flex">
                <div id="div_ttuz23zjlz" class="color-o-4">
                  ({{ $translateLang('注意') }}:
                </div>
                <div>
                  <div id="div_x2sxs38iy8" class="ml10 color-o-4">
                    1、{{
                      $translateLang(
                        '启用后仅柜柜中焊接板属性的小板才会使用锯片加工，非焊接板将直刀切割'
                      )
                    }}
                  </div>
                  <div class="ml10 color-o-4">
                    2、{{
                      $translateLang(
                        '启用后使用"自定义大板排版顺序"时焊接板将不会使用标准大板进行排版，只会使用特殊大板排版'
                      )
                    }}
                  </div>
                  <div id="div_9othgif5z1" class="ml10 color-o-4">
                    3、{{
                      $translateLang('启用该功能后排版方案必须使用锯切排板')
                    }})
                  </div>
                </div>
              </div>
            </div>
            <!-- 焊接板排版间隙 -->
            <div
              class="cut-setting-item div-margin pt10 mb20 ml20"
              v-show="
                formData.sawToLayout &&
                formData.sawCutOnlyWeld &&
                formData.processType === 'weldingPlank'
              "
            >
              <span class="color-o-9 mr8">
                {{ $translateLang('焊接板排版间隙') }}
              </span>
              <a-input
                id="engraving_setting_sawBoardGap_input"
                v-model="formData.sawBoardGap"
                style="width: 150px"
                suffix="mm"
                @blur="inputBlur('sawBoardGap')"
                @input="
                  inputLimit({
                    value: formData.sawBoardGap,
                    formData: formData,
                    keys: ['sawBoardGap'],
                    rule: '5-2',
                  })
                "
              ></a-input>
            </div>
            <div
              class="cut-setting-item div-margin pt10 mb20"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <span class="color-o-9 mr8">
                {{ $translateLang('最小余料匹配宽度差') }}
              </span>
              <a-input
                id="engraving_setting_minSurplusWidthDiff_input"
                v-model="formData.minSurplusWidthDiff"
                style="width: 118px"
                suffix="mm"
                @input="
                  inputLimit({
                    value: formData.minSurplusWidthDiff,
                    formData: formData,
                    keys: ['minSurplusWidthDiff'],
                    rule: '5-2',
                    isThickFlag: true,
                  })
                "
              ></a-input>
              <span class="color-o-4 ml10"
                >({{
                  $translateLang(
                    '仅当小板与余料的宽度差小于此值时，小板才会排在余料上'
                  )
                }})</span
              >
            </div>
            <div
              class="cut-setting-item div-margin pt10 mb20"
              v-show="
                formData.sawToLayout && formData.processType === 'weldingPlank'
              "
            >
              <span class="color-o-9 mr8">
                {{ $translateLang('开料直刀切割路径主体改用锯片') }}
              </span>
              <a-checkbox
                id="engraving_setting_sawReplaceEnable_input"
                v-model="formData.sawReplace.sawReplaceEnable"
              ></a-checkbox>
            </div>
            <div
              class="cut-setting-item div-margin pt10 mb20"
              v-show="
                formData.sawToLayout &&
                formData.sawReplace.sawReplaceEnable &&
                formData.processType === 'weldingPlank'
              "
            >
              <span class="color-o-9 mr8">
                {{ $translateLang('最短改用锯片的距离') }}
              </span>
              <a-input
                id="engraving_setting_minSawLength_input"
                v-model="formData.sawReplace.minSawLength"
                style="width: 118px"
                suffix="mm"
                @input="
                  inputLimit({
                    value: formData.sawReplace.minSawLength,
                    formData: formData.sawReplace,
                    keys: ['minSawLength'],
                    rule: '5',
                  })
                "
              ></a-input>
            </div>
            <div
              class="cut-setting-item div-margin pt10 mb20"
              v-show="
                formData.sawToLayout &&
                formData.sawReplace.sawReplaceEnable &&
                formData.processType === 'weldingPlank'
              "
            >
              <span class="color-o-9 mr8">
                {{ $translateLang('相邻更宽板间保留的开料直刀切割距离') }}
              </span>
              <a-input
                id="engraving_setting_keepDistance_input"
                v-model="formData.sawReplace.keepDistance"
                style="width: 118px"
                suffix="mm"
                @input="
                  inputLimit({
                    value: formData.sawReplace.keepDistance,
                    formData: formData.sawReplace,
                    keys: ['keepDistance'],
                    rule: '5',
                  })
                "
              ></a-input>
              <span class="color-o-4 ml10"
                >({{
                  $translateLang(
                    '注意：要留够充足的距离，不然锯片会切到旁边板件'
                  )
                }})</span
              >
            </div>
            <!-- 先切断余料的横切路径 -->
            <div
              class="cut-setting-item div-margin"
              v-show="formData.processType === 'weldingPlank'"
            >
              <span
                id="span_jkepp5ptr0"
                class="color-o-9 mr8 cut-surplus-path"
                >{{
                  $t('cuttingDock.sawEngraving.generateCutSurplusPath')
                }}</span
              >
              <a-checkbox
                class="mr20"
                v-model="formData.firstCutSurplus"
                @change="handleChangeFirstSurplus"
                id="engraving_setting_firstCutSurplus_checkbox"
              ></a-checkbox>
            </div>
            <div
              class="pl10"
              v-if="
                formData.firstCutSurplus &&
                formData.processType === 'weldingPlank'
              "
            >
              <!-- 切断后的余料可入库和打印标签 -->
              <div class="mt8" style="display: flex; align-items: center">
                <div class="flex items-center flex-box--0 mr">
                  <span class="color-o-9 mr8">
                    {{ $translateLang('切断后的余料可入库和打印标签') }}
                  </span>
                  <a-checkbox
                    v-model="formData.surplusStoreAndLabeling"
                    id="engraving_setting_surplusStoreAndLabeling_checkbox"
                  ></a-checkbox>
                </div>
                <div class="flex color-o-4">
                  <div class="flex-box--0">
                    {{ $translateLang('（启用后') }}：
                  </div>
                  <div class="flex flex-dir--top">
                    <span>{{
                      $translateLang(
                        '1、大板顶部或底部将生成蓝色余料区，该余料区可正常入库和打印标签'
                      )
                    }}</span>
                    <span>{{
                      $translateLang('2、焊接板将不生效"余料自动裁剪"功能）')
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- 余料最小可用尺寸 -->
              <div
                class="cut-setting-item mt8 flex-wrap"
                v-if="
                  formData.firstCutSurplus &&
                  formData.surplusStoreAndLabeling &&
                  formData.processType === 'weldingPlank'
                "
              >
                <span class="color-o-9 mr8 flex-box--0">
                  {{ $translateLang('余料最小可用尺寸') }}：
                </span>
                <span class="color-o-9 mr4">{{ $translateLang('宽度') }}</span>
                <a-input
                  v-model="formData.surplusMinWidth"
                  suffix="mm"
                  class="mr12"
                  style="width: 120px"
                  @blur="inputCheckSurplusMinSize('surplusMinWidth')"
                ></a-input>
                <span class="color-o-9 mr4">{{ $translateLang('长度') }}</span>
                <a-input
                  v-model="formData.surplusMinLength"
                  suffix="mm"
                  class="mr12"
                  style="width: 120px"
                  @blur="inputCheckSurplusMinSize('surplusMinLength')"
                  id="engraving_setting_surplusMinLength_input"
                ></a-input>
                <a-checkbox
                  v-model="formData.crossCutOnlyMinSurplusSize"
                  class="mr4"
                  @change="handleChangeCrossCutOnlyMinSurplusSize"
                ></a-checkbox>
                <span class="color-o-4"
                  >（{{
                    $translateLang('余料满足最小可用尺寸才生成横切余料路径')
                  }}）</span
                >
              </div>
              <!-- 反面截断余料 -->
              <div
                class="mt8"
                style="display: flex; align-items: center"
                v-show="
                  formData.firstCutSurplus &&
                  formData.processType === 'weldingPlank'
                "
              >
                <newContent :is-new-content="false">
                  <span
                    id="span_bbkvwglm9n"
                    class="color-o-9 mr8 cut-surplus-path"
                    >{{ $translateLang('反面截取余料') }}</span
                  >
                </newContent>
                <a-checkbox
                  id="checkbox_backCutSurplus"
                  v-bp="'engraving:backCutSurplus'"
                  class="mr20"
                  v-model="formData.backCutSurplus"
                ></a-checkbox>
                <span class="color-o-4"
                  >({{
                    $translateLang(
                      '启用后请将反面修边顺序设置为"反面孔槽加工后修边"'
                    )
                  }})</span
                >
              </div>
            </div>
          </div>
          <div class="saw-img">
            <img src="@/assets/image/saw_setting.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import { getFiveSixDrillFileType } from '@/apis/equipment'
import newContent from '@/components/newContent.vue'
import pageTable from '@/components/page-table'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi, genUniId } from '@/util/commonFuncs'
import { verifyInputNumber } from '@/util/commonFuncs.js'
import { regReplaceCuttingParamsInputCheck } from '@/util/regReplace'

import { mentaojiConfig } from './config/tableConfig'
import RobotArmSetting from './robotArmSetting.vue'

export default {
  components: {
    pageTable,
    newContent,
    RobotArmSetting,
  },
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    ncExportSetting: {
      type: [Array, Object],
      default: () => ({}),
    },
    // 机械臂对接设置，与自动线对接共用同一份数据
    roboticArmSetting: {
      type: Object,
      default: () => ({}),
    },
    // 机械臂模板列表，由 robotArmDocking 加载后经父级传入
    roboticOptions: {
      type: Array,
      default: () => [],
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 冻结 不可修改
      tableConfig: Object.freeze(mentaojiConfig),
      formData: {
        mentaoji_enable: false,
        // 门套机
        mentaoji_saws: [],
        // 加工工艺
        processType: 'weldingPlank',
        // 锯切修边
        sawToTrim: true,
        // 锯片切割下料
        sawToCut: true,
        // 不生成纵向锯片切割路径
        noVerticalSaw: false,
        mentaojiSize: 20,
        mentaojiSizeSetting: true,
        // 一刀拉穿
        sawThrough: true,
        // 一刀拉穿值
        sawThroughSize: 20,
        // 启用锯片厚度排版
        sawToLayout: false,
        // 已封好不再切的大板边
        edgeNoSaw: false,
        // 封好的边
        edgeNoSawSide: 'left',
        // 相同宽度小板
        sameWidthPlank: false,
        // 不生成空路径
        noCutEmptyPath: false,
        // 启用切割余料路径
        firstCutSurplus: false,
        // 切断后的余料可入库和打印标签
        surplusStoreAndLabeling: false,
        // 余料最小可用宽度
        surplusMinWidth: 0,
        // 余料最小可用长度
        surplusMinLength: 0,
        // 余料满足最小可用尺寸才生成横切余料路径
        crossCutOnlyMinSurplusSize: false,
        // 反面截取余料
        backCutSurplus: false,
        // 焊接板才使用锯片加工
        sawCutOnlyWeld: false,
        minSurplusWidthDiff: '',
        // 焊接板排版间隙
        sawBoardGap: 0,
        // 按板件长度依次排版
        sortByHeight: 'bottom',
        // 一体机设置
        saw_aio_setting: {
          // 一体机权限
          saw_aio_auth: false,
          // 一体机开关
          saw_aio_enable: false,
          // 一体机模板
          saw_aio_model: '',
        },
        sawReplace: {
          // 开料直刀切割路径主体改用锯片
          sawReplaceEnable: false,
          // 最短改用锯片的距离
          minSawLength: 100,
          // 相邻更宽板间保留的开料直刀切割距离
          keepDistance: 30,
        },
      },
      // 五六面钻模板
      dockFiveSixTemplates: [],
      // 门套机选中行
      mentaojiCurrentRow: {},
      // 已封好边不再切方向
      edgeDirArr: [
        { label: 'cuttingDock.sawEngraving.top', value: 'top' },
        { label: 'cuttingDock.sawEngraving.bottom', value: 'bottom' },
        { label: 'cuttingDock.sawEngraving.left', value: 'left' },
        { label: 'cuttingDock.sawEngraving.right', value: 'right' },
      ],
      isNotEnableSawAioModel: false,
      isSawAioAuth: false,
    }
  },
  computed: {
    isEditionId() {
      let { edition_id } = store.state.userInfo
      // [5, 6, 12, 13, 14, 19, 20] 工厂v2及以上版本id
      return [5, 6, 12, 13, 14, 19, 20].includes(edition_id)
    },
  },
  watch: {
    async obj() {
      if (Object.keys(this.obj).length > 0) {
        let s = JSON.parse(JSON.stringify(this.obj))
        this.formData = s
        if (this.dockFiveSixTemplates.length === 0) {
          await this.getFiveSixDrillFileType()
        }
      }
    },
    async 'formData.saw_aio_setting.saw_aio_model'(val) {
      if (val) {
        if (this.dockFiveSixTemplates.length === 0) {
          await this.getFiveSixDrillFileType()
        }
        const index = this.dockFiveSixTemplates.findIndex(
          (item) => item.dock56Format == val
        )
        if (index === -1) {
          this.formData.saw_aio_setting.saw_aio_model = ''
          this.isNotEnableSawAioModel = true
        }
      }
    },
  },
  methods: {
    handleRobotArmEnableChange(value) {
      this.$set(this.roboticArmSetting, 'enable', value)
    },
    handleRobotArmModelChange(value) {
      this.$set(this.roboticArmSetting, 'robotic_arm_model', value)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.sawEngravingRef.scrollTo({
          top: 1000,
          behavior: 'smooth',
        })
      })
    },
    inputCheckSurplusMinSize(key) {
      let num = [this.formData[key]]
      let minusSymbol = num.includes('-') ? '-' : ''
      num = verifyInputNumber(num[0], num, ['0'], '5-2')
      let result = Number(minusSymbol + num)
      result = Math.min(result, 99999.99)
      this.formData[key] = Number(result)
      // 这里添加保存埋点逻辑
      buryPointApi('engraving', key)
    },
    handleChangeCrossCutOnlyMinSurplusSize(val) {
      buryPointApi('engraving', 'crossCutOnlyMinSurplusSize')
    },
    inputBlur(key) {
      this.formData[key] = Number(this.formData[key])
    },
    inputLimit(option) {
      verifyInputNumber(
        option.value,
        option.formData,
        option.keys,
        option.rule,
        option.isMinus,
        option.min,
        option.isEmpty,
        option.max,
        option.isThickFlag
      )
    },
    translateLang(key) {
      return translate(key)
    },
    //门套机插入行
    addLineMentaoji() {
      const initData = {
        serial_num: this.formData.mentaoji_saws.length + 1,
        saw_width: '',
        saw_direction: 'H',
        cut_from: '0000',
        x_offset: '',
        y_offset: '',
        move_speed: '',
        cut_speed: '',
        start_code: '',
        end_code: '',
        saw_down_code: '',
        saw_up_code: '',
        abscissa: 'X',
        ordinate: 'Y',
        webId: genUniId(),
      }
      this.formData.mentaoji_saws.push(initData)
    },
    //门套机删除行
    deleteLineMentaoji() {
      let deleteRowIndex = this.formData.mentaoji_saws.findIndex(
        (item) => item == this.mentaojiCurrentRow
      )
      if (this.formData.mentaoji_saws.length != 0) {
        this.formData.mentaoji_saws.splice(deleteRowIndex, 1)
        // 删除数据后需要对所有的数据进行编号重新排序
        // 判断删除的数据是否是最后一个，避免多余的循环排序，删除数据是最后一个时不需要走重新编号逻辑
        if (deleteRowIndex !== this.formData.mentaoji_saws.length) {
          for (
            let index = 0;
            index < this.formData.mentaoji_saws.length;
            index++
          ) {
            this.formData.mentaoji_saws[index].serial_num = index + 1
          }
        }
      }
    },
    // 空走速度 || 加工速度 输入校验
    tableInputChange(row, prop) {
      const oldValue = row[prop] + ''
      if (prop == 'saw_width' || prop == 'move_speed' || prop == 'cut_speed') {
        verifyInputNumber(row[prop], row, [prop], '5-3')
      }
      if (prop == 'x_offset' || prop == 'y_offset') {
        verifyInputNumber(row[prop], row, [prop], '5-2', true)
      }
      if (
        (prop === 'move_speed' && row[prop] == 0 && oldValue != 0) ||
        (prop === 'cut_speed' && row[prop] == 0 && oldValue != 0) ||
        (prop === 'x_offset' && row[prop] == 0 && oldValue != 0) ||
        (prop === 'y_offset' && row[prop] == 0 && oldValue != 0)
      ) {
        row[prop] = ''
      }
      if (!oldValue) {
        row[prop] = ''
      }
    },
    // 选中门套机选项
    clickRow(row) {
      this.mentaojiCurrentRow = row
    },
    // 输入检验
    inputCheck(val, type, decimal, positive, max) {
      // 只为正整数
      if (type) {
        this.formData[val] = this.formData[val].replace(/[^\d]/g, '') // 去除数字和小数点以外的数字
      } else {
        // 可以为正负数
        this.formData[val] = regReplaceCuttingParamsInputCheck(
          this.formData[val]
        )

        // 第五个参数加上是为了控制只能输入正数及小数不能输入负数,并返回，走小数限制会只能输入两位
        if (positive) {
          this.formData[val] = this.formData[val].replace(/[^\d*\.]/g, '')
          return
        }
        if (decimal) {
          this.formData[val] = this.formData[val].replace(
            /^(\-)*(\d+)\.(\d\d).*$/,
            '$1$2.$3'
          )
        }
        if (max) {
          if (this.formData[val] > max) {
            this.formData[val] = max
          }
        }
      }
    },
    // 使用门套相关处理
    handleChangeProcessType() {
      if (this.formData.processType === 'doorFrame') {
        this.formData.sawToTrim = true
        this.formData.sawToCut = true
        this.formData.mentaojiSizeSetting = false
      }
    },
    // 启用锯片厚度排版相关处理
    handleChangeThickLay() {
      if (this.formData.sawToLayout) {
        this.formData.sawToTrim = true
        this.formData.sawToCut = true
        this.formData.mentaojiSizeSetting = false
      }
    },
    // 选择已封好边
    handleSelectEdge(val) {
      this.formData.edgeNoSawSide = val
    },
    handleChangeFirstSurplus(val) {
      if (val.target.checked) {
        this.$nextTick(() => {
          const element = document.getElementById('checkbox_backCutSurplus')
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start',
            })
          }
        })
      }
    },
    // 获取锯切一体机权限
    async getSawAioPermission() {
      const res = await fetchUserPermission({ permission_type: 'SAW_AIO' })
      if (res.status === 1) {
        this.isSawAioAuth = res.data.enable
      }
    },
    async handleChangeExportPlankData() {
      const checked = this.formData.saw_aio_setting.saw_aio_enable
      // 有锯切一体机权限且启用锯切雕刻机时 且 柜柜版本为v2及以上版本
      const canToggle =
        (this.isSawAioAuth || this.isEditionId) && this.formData.mentaoji_enable
      if (canToggle) {
        return
      }
      if (checked) {
        this.$message({
          message: this.$t('cuttingDock.sawEngraving.sawAioTip'),
          type: 'info',
        })
        this.$nextTick(() => {
          this.formData.saw_aio_setting.saw_aio_enable = false
        })
      }
    },
    // 获取五六面钻模板
    async getFiveSixDrillFileType() {
      try {
        const res = await getFiveSixDrillFileType({ from: 'user' })
        if (res.status === 1) {
          this.dockFiveSixTemplates = res.data.model_list.filter(
            (item) => !!item.saw_aio_enable
          )
        }
      } catch (err) {
        if (err?.message === 'canceled') return
        throw err
      }
    },
    handleChangeSawAioModel() {
      this.isNotEnableSawAioModel = false
    },
    filterSawAioOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
  },

  mounted() {
    this.getSawAioPermission()
    // this.getFiveSixDrillFileType()
  },
}
</script>

<style lang="less" scoped>
.saw-engraving-setting {
  padding: 10px 0 0 24px;
  .saw-engraving-setting-header {
    flex-direction: column;
  }
  .export_data_setting {
    margin-top: 20px;
    // display: flex;
  }
  .title {
    color: rgba(0, 0, 0, 0.9);
    font-weight: 700;
    font-size: 20px;
  }
  .knives-store {
    margin-top: 25px;
    .main-table {
      box-sizing: border-box;
      padding: 20px 0 16px 0;
      /deep/.el-table {
        &::before {
          background: transparent;
        }
        .has-gutter tr {
          background-color: #fafafa;
        }
        .el-table__cell.gutter {
          background-color: rgb(250, 250, 250);
        }
        .hidden-columns {
          display: none;
        }
        .knives_type {
          .icon-revise-show {
            display: none;
          }
          &:hover .icon-revise-show {
            display: inline-block;
          }
        }
      }
    }
    .operation-btn {
      box-sizing: border-box;
      .danger-btn {
        color: #ff4d4f;
        &.ant-btn {
          border-color: #ff4d4f;
        }
      }
    }
  }
  .cut-setting {
    margin-top: 36px;
    margin-bottom: 36px;
    &-item {
      display: flex;
      align-items: center;
      margin-top: 24px;
      .label {
        display: inline-block;
        width: 112px;
        margin-right: 16px;
        color: rgba(0, 0, 0, 0.9);
      }
      .edge-warp {
        border-radius: 3px;
        > span {
          display: inline-block;
          width: 66px;
          height: 32px;
          color: rgba(0, 0, 0, 0.9);
          line-height: 30px;
          text-align: center;
          border: 1px solid #dcdcdc;
          cursor: pointer;
          transition: all 0.5s;

          &:nth-child(1) {
            margin-right: -1px;
          }

          &:nth-child(2) {
            margin-right: -1px;
          }

          &:nth-child(3) {
            margin-right: -1px;
          }

          &:hover {
            z-index: 2;
            margin-right: 0;
            color: #18a8c7;
            border-color: #18a8c7;
          }
        }

        > span.active {
          z-index: 2;
          margin-right: 0;
          color: #18a8c7;
          border-color: #18a8c7;
        }
      }
      &:last-child {
        margin-bottom: 20px;
      }
    }
    .saw-img {
      margin-top: 75px;
    }
    .title-cut-set {
      .new-button_text {
        top: -8px;
        right: -40px;
      }
    }
    /deep/.title-cut-set {
      .new-button_text {
        top: -8px;
        right: -40px;
        width: 36px;
        color: rgba(0, 0, 0, 0.65);
        background-color: #f9e0c7;
      }
    }
  }
}
.label-width {
  width: 120px !important;
}
.div-margin {
  margin-top: 0px !important;
}
.flex-wrap {
  flex-wrap: wrap;
  row-gap: 8px;
}
.down_line {
  color: red;
  margin-left: 24px;
}
</style>
